<template lang="pug">
    emoji-picker.emoji-picker-control(@emoji='append' :search='search')
      .emoji-invoker(slot='emoji-invoker' slot-scope='{ events: { click: clickEvent } }' @click.stop='clickEvent')
        svg-icon(iconId="smile-face")
      div(slot='emoji-picker' slot-scope='{ emojis, insert, display }')
        .emoji-picker(:style="{ top: '-304px', left: '32px' }")
          .emoji-picker__search
            input(type='text' v-model='search' v-focus='')
          div
            div(v-for='(emojiGroup, category) in emojis' :key='category')
              h5 {{ category }}
              .emojis
                span(v-for='(emoji, emojiName) in emojiGroup' :key='emojiName' @click='insert(emoji)' :title='emojiName') {{ emoji }}
</template>

<script>
import EmojiPicker from 'vue-emoji-picker'

export default {
    name: 'emoji-picker-control',
    components: {
        EmojiPicker,
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        append(emoji) {
            this.$emit('append', emoji)
        },
    },
    directives: {
        focus: {
            inserted(el) {
                el.focus()
            },
        },
    },
}
</script>
